import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';
import { LocalVimeoPlayerComponent } from '../../ui/display/media/vimeo-player.component';

/**
 * Block content interface
 */
export interface IGiftboxIntroductionContent extends NICmsContentComponent.IData {
    title?: string;
    title_icon?: string;
    image?: string;
    video?: string;
    upsell_points?: {
        text: string;
    }[];
}

/**
 * Component definition
 */
@Component({
    selector: 'giftbox-introduction',
    templateUrl: './giftbox-introduction.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, ICmsClientModule, LocalVimeoPlayerComponent]
})
@ICmsComponent<GiftboxIntroductionComponent>({
    id: 'giftbox-tray-introduction',
    block: {
        url: 'giftbox-tray-introduction'
    },
    onDemandOnly: true,
    name: 'Giftbox introduction',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title_icon',
            title: 'Title Icon'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'video',
            title: 'Video (Vimeo link)'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'upsell_points',
            title: 'Upsell Points',
            itemName: 'Line',
            itemNameField: 'text',
            defaultSize: 3,
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Copy',
                    required: true
                }
            ]
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'bottom_text',
            title: 'Bottom text'
        }
    ]
})
export class GiftboxIntroductionComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IGiftboxIntroductionContent;
}
